// extracted by css-extract-rspack-plugin
export default {"footerWrapper":"footer-wrapper--dmCPk6A8xzoabjiV","rowWrapper":"row-wrapper--cElxLuYQB1suKJCw"};